import { DateTime } from 'luxon';

/**
 *
 * @param {string} word
 * @returns {string}
 */
export const capitalCase = word =>
  word.slice(0, 1).toUpperCase() + word.slice(1);
export const getFormattedDate = date => {
  return date
    ? `${DateTime.fromFormat(date, 'dd-MM-yyyy').toFormat('dd MMM yyyy')}, `
    : '';
};
export const getFormattedTime = (startTime, endTime) => {
  let formattedTime = '';
  if (startTime) {
    formattedTime += startTime;
  }
  if (endTime) {
    formattedTime = `${formattedTime} - ${endTime}`;
  }
  return formattedTime;
};
export const getFormattedStatus = status => {
  return status ? status.replace(/_/g, ' ') : '';
};
export const getFormattedTrackingUpdate = (shipmentType, update) => {
  const both = {
    out_for_delivery_from: 'Out for delivery from',
    received_at: 'Received at',
    received_at_destination_hub: 'Received at destination hub',
    delivered_at: 'Delivered at',
    partially_delivered_at: 'Partially delivered at',
    failed_to_deliver_at: 'Failed to deliver at',
    reattempted_to_deliver_from: 'Reattempting delivery from',
    reattempt_to_pickup_from: 'Reattempting pickup from',
    customer_needs_rescheduling: 'Customer requested reschedule, awaiting date confirmation',
    priority_reschedule: 'Rescheduled on High Priority basis',
    reschedule_for_later_date: 'Rescheduled on customer request',
    failed_to_pickup_from: 'Failed to pickup from',
    requested_reschedule: 'Customer requested reschedule',
    rescheduled: 'Rescheduled ',
    technician_on_the_way: 'Technician on the way',
    service_request_done: 'Service done',
    service_request_rescheduled: 'Service rescheduled',
    service_request_cancelled: 'Service cancelled',
    rto_requested: 'RTO Requested',
    rto_items_confirmed: 'RTO Items Confirmed',
    rto_in_transit: 'RTO In Transit',
  };
  const formattedUpdates = {
    reverse: {
      ...both,
      dispatched_from: 'Reverse pickup done from',
      out_for_pickup_from: 'Out for reverse pickup',
      returned_to: 'Returned to',
    },
    others: {
      ...both,
      dispatched_from: 'dispatched from',
      out_for_pickup_from: 'Out for pickup',
      returned_to: 'Returned to hub',
    },
  };
  return formattedUpdates[shipmentType === 'reverse' ? 'reverse' : 'others'][
    update
    ];
};
export const getFormattedActualTime = startTimeISO =>
  DateTime.fromISO(startTimeISO).toFormat('dd-MMM-yyyy, HH:mm');
export const getFormattedRelativeTime = startTimeISO =>
  DateTime.fromISO(startTimeISO).toRelative();
export const getFormattedShipmentStatus = (shipmentType, shipmentStatus) => {
  const both = {
    delivered: 'delivered',
    delivered_and_installed: 'delivered',
    delivered_installation_pending: 'delivered, Not installed',
    in_transit: 'In transit',
    received_at_destination_hub: 'Received at destination hub',
    out_for_pickup: 'Out for pickup',
    out_for_delivery: 'Out for delivery',
    cancelled: 'Cancelled',
    partially_delivered: 'Partially Delivered',
    failed_to_deliver: 'Failed to deliver',
    failed_to_pickup: 'Failed to pickup',
    customer_requested_reschedule: 'Waiting customer confirmation',
    replan_required: 'Rescheduled',
    rescheduled: 'Rescheduled',
  };

  const formattedStatuses = {
    reverse: {
      ...both,
      created: 'Awaiting reverse pickup',
      manifested: 'Awaiting reverse pickup',
      picked_up: 'Picked up',
      partial_picked_up: 'Partially picked up',
    },
    others: {
      ...both,
      created: 'Ready for dispatch',
      manifested: 'Ready for dispatch',
      picked_up: 'Dispatched',
      partial_picked_up: 'Partially dispatched',
      rto_requested: 'RTO Requested',
      rto_in_transit: 'RTO Processed',
      rto_items_confirmed: 'RTO Processed',
      returned_to_shipper: 'Returned to shipper',
    },
  };
  return formattedStatuses[shipmentType === 'reverse' ? 'reverse' : 'others'][
    shipmentStatus
    ];
};
